import {
    UPDATE_REVIEW_START,
    UPDATE_REVIEW_SUCCESS,
    UPDATE_REVIEW_ERROR,
} from '../../../constants';
import showToaster from '../../../helpers/showToaster';
import { updateReview as mutation, getReviewsDetails } from '../../../lib/graphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

export function updateReviewStatus(id, type, currentPage, searchList) {
    return async (dispatch, getState, { client }) => {
        try {

            const isRestrict = await dispatch(demoRestriction({}));
            if (isRestrict) return;

            dispatch({
                type: UPDATE_REVIEW_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: { id, type },
                refetchQueries: [{
                    query: getReviewsDetails,
                    variables: {
                        currentPage,
                        searchList
                    }
                }]
            });

            if (data?.updateReview?.status === "success") {
                dispatch({
                    type: UPDATE_REVIEW_SUCCESS,
                });
                showToaster({ messageId: 'updateBanner', toasterType: 'success' })
            } else {
                dispatch({
                    type: UPDATE_REVIEW_ERROR,
                    payload: {
                        status
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_REVIEW_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}
